module.exports = __webpack_public_path__ + "img/tickets-r3-datacenter-access.0139830c.png";